var Errors = {
  WINDOW_NOT_LOADED: "Window not loaded"
};
module.exports = Errors;